import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetActiveResearcherProjectsRPC } from "./getActiveResearcherProjectsRPC";

export class GetActiveResearcherProjectsRPCClientImpl extends GetActiveResearcherProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetActiveResearcherProjectsRPC.Request): Promise<LeoRPCResult<GetActiveResearcherProjectsRPC.Response, GetActiveResearcherProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetActiveResearcherProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetActiveResearcherProjectsRPC.ResponseDTO,
      GetActiveResearcherProjectsRPC.Errors.ErrorsDTO,
      GetActiveResearcherProjectsRPC.Response,
      GetActiveResearcherProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetActiveResearcherProjects",
      GetActiveResearcherProjectsRPC.Response.fromDTO,
      GetActiveResearcherProjectsRPC.Errors.fromDTO
    );
  }
}
